// extracted by mini-css-extract-plugin
export default {"dropzone":"style_dropzone__ZgeF+","disabled":"style_disabled__hkvQ5","link":"style_link__MlNy+"};